import { useEffect, useRef } from "react"

const HandleDropdownClose = (callbackFn: () => void) => {
  const domNodeRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        domNodeRef.current &&
        !domNodeRef.current.contains(e.target as Node)
      ) {
        callbackFn()
      }
    }

    document.addEventListener("mousedown", handleClickOutside)

    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [callbackFn])

  return domNodeRef
}

export default HandleDropdownClose
